import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const ROLE_LABELS = {
  super_admin: "HV Super Admin",
  head_office_admin: "Head Office Admin",
  franchise_owner: "Franchise Owner",
  location_manager: "Location Manager",
  trainer: "Trainer",
  client: "Client / Dog Owner",
};
